export interface RichiestaPraticaDTO {
  codiceTipoPratica?: string;
  valori?: { [key: string]: any };
  recaptchaToken?: string;
}

export interface NuovaPraticaResultDTO {
  codicePratica?: string;
  messaggio?: string;
  tipoConferma?: string;
  emailDestinatario?: string;
  telefonoDestinatario?: string;
}

export interface GenericResponseDTO {
  messaggio?: string;
  esito?: boolean;
  codice?: string;
}
